module.exports = __webpack_public_path__ + "media/images/vector_plus_with_side_dots-cd5f0f5570d48096ff4d623a036b8ba5.svg";